import { sendGet, sendPost } from "~/api/base";
import { getAPIData } from "../helpers";
import { IStoreConnect, IStoreLoginRequest } from "./types";

// The API answers `{ shop: null }` when the user has no shop yet (it used to
// be a 404, logged as an error on every page). Unwrap it so callers keep
// getting the shop or null.
export const getStoreInfo = () =>
  getAPIData(sendGet("shop/")).then((data) =>
    data && typeof data === "object" && "shop" in data ? data.shop : data
  );

export const storeLogin = (params: IStoreLoginRequest) =>
  getAPIData(sendPost("shop_login/", params));

export const storeConnect = (params: IStoreConnect) =>
  getAPIData(sendPost("connect/shopify/", params));

export const getShopifyProducts = () =>
  getAPIData(sendGet("shopify/products/"));

export const getShopifyCollections = () =>
  getAPIData(sendGet("shopify/collections/"));
